import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AdminGuard from 'utils/route-guard/AdminGuard';

const Channel = Loadable(lazy(() => import('views/Channel')));
const Log = Loadable(lazy(() => import('views/Log')));
const Redemption = Loadable(lazy(() => import('views/Redemption')));
const Setting = Loadable(lazy(() => import('views/Setting')));
const Token = Loadable(lazy(() => import('views/Token')));
const Topup = Loadable(lazy(() => import('views/Topup')));
const FundRecords = Loadable(lazy(() => import('views/FundRecords')));
const User = Loadable(lazy(() => import('views/User')));
const Profile = Loadable(lazy(() => import('views/Profile')));
const NewsManagement = Loadable(lazy(() => import('views/News/NewsManagement')));
const UcodexRelease = Loadable(lazy(() => import('views/UcodexRelease')));
const Kyc = Loadable(lazy(() => import('views/Kyc')));
const AdminKycManagement = Loadable(lazy(() => import('views/Kyc/AdminKycManagement')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));

// dashboard routing
const Dashboard = Loadable(lazy(() => import('views/Dashboard')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/panel',
  element: <MainLayout />,
  children: [
    {
      path: '',
      element: <Dashboard />
    },
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'channel',
      element: <Channel />
    },
    {
      path: 'log',
      element: <Log />
    },
    {
      path: 'redemption',
      element: <Redemption />
    },
    {
      path: 'setting',
      element: <Setting />
    },
    {
      path: 'token',
      element: <Token />
    },
    {
      path: 'topup',
      element: <Topup />
    },
    {
      path: 'fund-records',
      element: <FundRecords />
    },
    {
      path: 'user',
      element: <User />
    },
    {
      path: 'news',
      element: <NewsManagement />
    },
    {
      path: 'ucodex-release',
      element: <AdminGuard><UcodexRelease /></AdminGuard>
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: 'kyc',
      element: <Kyc />
    },
    {
      path: 'kyc-management',
      element: (
        <AdminGuard>
          <AdminKycManagement />
        </AdminGuard>
      )
    },
    {
      path: '404',
      element: <NotFoundView />
    }
  ]
};

export default MainRoutes;
